// Copy one of the following URLs into your env file:
// Prod: 'https://api.boilerroom.tv'
// Staging (also the default if you don't fill in .env): 'https://api.staging.boilerroom.tv'
// Local: 'http://localhost:3001'

export default process.env.STASHLESS_URL || 'https://api.staging.boilerroom.tv'
